module.exports = __webpack_public_path__ + "img/spectrum-logo.8f4ece20.jpg";